

export default function (aboutAnchor) {
    const articleElements = document.querySelectorAll('.about-content-articles-article');
    const headerNavigationElements = document.querySelectorAll('.sublink[data-about]');
    const aboutButtonElements = document.querySelectorAll('.about-content-navigation > button');

    function processAboutElementClickEvent(aboutButtonElements, articleElements, newAboutElementAnchor) {
        aboutButtonElements.forEach(buttonElement => {
            buttonElement.classList.toggle('active', newAboutElementAnchor === buttonElement.dataset.anchor);
        });
        articleElements.forEach(articleElement => {
            articleElement.classList.toggle('active', newAboutElementAnchor === articleElement.dataset.anchor);
        });
    }

    function triggerAboutElementClick (anchor) {
        const customEvent = new CustomEvent('aboutEvent', {
            detail: {
                anchor: anchor,
            }
        })
        window.dispatchEvent(customEvent);
    }

    processAboutElementClickEvent(aboutButtonElements, articleElements, aboutAnchor)

    headerNavigationElements.forEach(headerNavigationElement => {
        headerNavigationElement.addEventListener('click', e => {
            processAboutElementClickEvent(aboutButtonElements, articleElements, headerNavigationElement.dataset.about);
            triggerAboutElementClick(headerNavigationElement.dataset.about);
        });
    });

    aboutButtonElements.forEach(aboutButtonElement => {
        aboutButtonElement.addEventListener('click', (e) => {
            processAboutElementClickEvent(aboutButtonElements, articleElements, aboutButtonElement.dataset.anchor);
            triggerAboutElementClick(aboutButtonElement.dataset.anchor);
        })
    });
}
